import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent, MatDialog } from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpExchangeQuoteDialog } from "./add-offramp-exchange-quote/add-offramp-exchange-quote.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-exchange-quotes",
  templateUrl: "./offramp-exchange-quotes.component.html",
  styleUrls: ["./offramp-exchange-quotes.component.css"],
})
export class OfframpExchangeQuotesComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oQuotes: any = [];
  quotes: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => {
    return true;
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.marginRight = '5px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, 'Offramp Exchange Quote');
          };
          container.appendChild(viewBtn);

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.style.marginRight = '5px';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          const deleteBtn = document.createElement('button');
          deleteBtn.type = 'button';
          deleteBtn.className = 'btn btn-sm btn-danger';
          deleteBtn.title = 'Delete';
          deleteBtn.innerHTML = '<i class="fa fa-trash"></i>';
          deleteBtn.onclick = (e) => {
            e.stopPropagation();
            this.deleteRecord(element);
          };
          container.appendChild(deleteBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 160
      },
      {
        headerName: 'User',
        field: 'adminid.name',
        valueGetter: (params) => {
          if (params.data && params.data.adminid && params.data.adminid.name) {
            return params.data.adminid.name;
          }
          return '';
        },
        flex: 1
      },
      {
        headerName: 'Liquidity Provider',
        field: 'liquidity_provider_id.name',
        valueGetter: (params) => {
          if (params.data && params.data.liquidity_provider_id && params.data.liquidity_provider_id.name) {
            return params.data.liquidity_provider_id.name;
          }
          return '';
        },
        flex: 1
      },
      { headerName: 'From Currency', field: 'from_currency', flex: 0.8 },
      { headerName: 'To Currency', field: 'to_currency', flex: 0.8 },
      { headerName: 'Rate', field: 'rate', flex: 0.8 },
      { headerName: 'Status', field: 'status', flex: 0.8 },
      { headerName: 'Communication Status', field: 'communication_status', flex: 1 },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  // Client-side search filter only (frontend filtering, does NOT call API)
  applyFilter(filterValue) {
    this.searchValue = filterValue || '';

    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }

    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      var search = searchValue.toLowerCase();
      this.quotes = this.oQuotes.filter(function (x) {
        return (
          (x.from_currency && x.from_currency.toLowerCase().includes(search)) ||
          (x.to_currency && x.to_currency.toLowerCase().includes(search)) ||
          (x.status && x.status.toLowerCase().includes(search)) ||
          (x.communication_status && x.communication_status.toLowerCase().includes(search)) ||
          (x.adminid && x.adminid.name && x.adminid.name.toLowerCase().includes(search)) ||
          (x.liquidity_provider_id && x.liquidity_provider_id.name && x.liquidity_provider_id.name.toLowerCase().includes(search)) ||
          (x._id && x._id.toLowerCase().includes(search))
        );
      });
    } else {
      this.quotes = this.oQuotes;
    }
  }

  // Calls API with date filters only (fromDate, toDate). Search is NOT sent to API.
  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpExchangeQuotes(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.quotes = list;
      this.oQuotes = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter('');
          this.quotes = this.oQuotes;
        }
      }

      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      } else {
        this.next_disabled = false;
      }
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp exchange quotes", defaults.notif);
    });
  }

  displayProperJson(jsonData, eventType) {
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Offramp Exchange Quote"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.searchValue = '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    this.quotes = this.oQuotes;
    this.getData();
  }

  addNewRecord() {
    const newRecord = {
      adminid: '',
      liquidity_provider_id: '',
      from_currency: '',
      to_currency: '',
      rate: 0,
      status: 'New',
      communication_status: 'New'
    };

    const dialogRef = this.dialog.open(AddOfframpExchangeQuoteDialog, {
      width: '700px',
      data: { record: newRecord, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Offramp exchange quote added successfully", defaults.notif);
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpExchangeQuoteDialog, {
      width: '700px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Offramp exchange quote updated successfully", defaults.notif);
        this.getData();
      }
    });
  }

  deleteRecord(record: any) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete this quote?`,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    }).afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinnerService.show();
        this.offrampService.deleteOfframpExchangeQuote({ _id: record._id, _csrf: this._csrf }).subscribe(
          (response: any) => {
            this.spinnerService.hide();
            if (response.status || response.success) {
              this.notifSer.success("Success", response.message || "Quote deleted successfully", defaults.notif);
              this.getData();
            } else {
              this.notifSer.error("Error", response.message || "Failed to delete quote", defaults.notif);
            }
          },
          (error) => {
            this.spinnerService.hide();
            this.notifSer.error("Error", (error.error && error.error.message) || "Failed to delete quote", defaults.notif);
          }
        );
      }
    });
  }

  exportArray() {
    this.spinnerService.show();

    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      page: 1,
      limit: 10000
    };

    this.offrampService.getAllOfframpExchangeQuotes(exportFilter).subscribe(
      (response: any) => {
        const list = (response && response.data) || [];
        if (list.length > 0) {
          const exportData = list.map((x: any) => ({
            ...x,
            adminid: x.adminid ? (x.adminid._id || x.adminid) : '',
            UserName: x.adminid ? x.adminid.name : '',
            liquidity_provider_id: x.liquidity_provider_id ? (x.liquidity_provider_id._id || x.liquidity_provider_id) : '',
            LiquidityProviderName: x.liquidity_provider_id ? x.liquidity_provider_id.name : '',
          }));
          TableUtil.exportArrayToExcel(exportData, 'OfframpExchangeQuotes');
        } else {
          this.notifSer.info("Info", "No data available to export", defaults.notif);
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", "Failed to export data. Please try again.", defaults.notif);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-exchange-quotes/offramp-exchange-quotes.component.ts